import {
  applySpec, pick, pipe, propOr,
} from 'ramda';

export const registerSpec = applySpec({
  user: pipe(
    propOr({}, 'user'),
    pick([
      'gender',
      'firstName',
      'lastName',
      'situation',
      'job',
      'streetAddress',
      'zipCode',
      'city',
      'phoneNumber',
      'country',
      'email',
      'communicationPreference',
      'communicationLanguage',
      'roleInCompany',
      'department',
      'salt',
      'verifier',
    ]),
  ),
  company: pipe(
    propOr({}, 'company'),
    pick(
      [
        'companyName',
        'numberOfEmployees',
        'industry',
        'website',
        'legalForm',
        'taxNumber',
        'commercialRegisterNumber',
        'streetAddress',
        'zipCode',
        'city',
        'country',
      ],
    ),
  ),
});

export const companyDetailsSpec = applySpec({
  company: pipe(
    propOr({}, 'company'),
    pick(
      [
        'companyName',
        'numberOfEmployees',
        'industry',
        'website',
        'legalForm',
        'taxNumber',
        'commercialRegisterNumber',
        'streetAddress',
        'zipCode',
        'city',
        'country',
      ],
    ),
  ),
});

export const accountDetailsSpec = applySpec({
  user: pipe(
    propOr({}, 'user'),
    pick([
      'gender',
      'firstName',
      'lastName',
      'streetAddress',
      'zipCode',
      'city',
      'phoneNumber',
      'country',
      'communicationPreference',
      'communicationLanguage',
      'roleInCompany',
      'department',
      'email',
    ]),
  ),
});
